import React from 'react';

import { useBoundStore } from 'store';
import { ReactComponent as SvgLogoDark } from 'shared/img/logo.dark.svg';
import { ReactComponent as SvgLogoLight } from 'shared/img/logo.light.svg';


export const Logo: typeof SvgLogoLight | typeof SvgLogoDark = (props) => {
  const { isLightMode } = useBoundStore((state) => ({ isLightMode: state.isLightMode }));

  if (isLightMode) {
    return <SvgLogoLight {...props} style={{ width: 140, height: 'auto', cursor: 'pointer', ...props.style }}/>;
  }
  return <SvgLogoDark {...props} style={{ width: 140, height: 'auto', cursor: 'pointer', ...props.style }}/>;
};
